import { render, staticRenderFns } from "./PNR_Pending.vue?vue&type=template&id=31a90370&scoped=true&"
import script from "./PNR_Pending.vue?vue&type=script&lang=js&"
export * from "./PNR_Pending.vue?vue&type=script&lang=js&"
import style0 from "./PNR_Pending.vue?vue&type=style&index=0&id=31a90370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a90370",
  null
  
)

export default component.exports